export const ThemeMode = {
  LIGHT: "light",

  DARK: "dark",

  SYSTEM: "system",
} as const;

export type ThemeModeType = (typeof ThemeMode)[keyof typeof ThemeMode];

export const THEME_MODE_VALUES = Object.values(ThemeMode);
